/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-undef */
// @ts-check

import jQuery from 'jquery';

/**
 * @param {typeof jQuery} $
 */
(function ($) {
  /**
   * Pops up an alert dialog using Boostrap
   *
   * @param {string} text what to say to user
   * @param {() => void} [okCallBack] optional callback for ok button
   * @param {string} [title] optional the title bar text
   */
  // @ts-expect-error
  $.fn.alert = function (text, okCallBack, title) {
    if (!title) {
      title = 'Alert';
    }

    let message = title;
    if (text) {
      message = '<div class="modal-body"><p>' + text + '</p></div>';
    }

    const config = {
      message,
      title: '<h1 class="modal-title">' + title + '</h1>',
      buttons: {
        ok: {
          label: 'Ok',
          className: 'btn-primary',
          callback() {},
        },
      },
    };

    if (typeof okCallBack == 'function') {
      config.buttons.ok.callback = okCallBack;
    }

    bootbox.dialog(config);
  };
  /**
   * Pops up a confirm dialog using Boostrap
   *
   * @param {string} text what we are asking the user to confirm
   * @param {() => void} [okCallBack] optional callback for ok button click
   * @param {() => void} [cancelCallBack] optional callback for cancel button click
   * @param {string} [title] optional the title bar text
   */
  // @ts-expect-error
  $.fn.confirm = function (text, okCallBack, cancelCallBack, title) {
    if (!title) {
      title = 'Confirm';
    }

    let message = title;
    if (text) {
      message = '<div class="modal-body"><p>' + text + '</p></div>';
    }

    const config = {
      message,
      title: '<h1 class="modal-title">' + title + '</h1>',
      buttons: {
        cancel: {
          label: 'Cancel',
          className: 'btn-default',
          callback() {},
        },
        ok: {
          label: 'Ok',
          className: 'btn-primary',
          callback() {},
        },
      },
    };

    if (typeof cancelCallBack === 'function') {
      config.buttons.cancel.callback = cancelCallBack;
    }

    if (typeof okCallBack == 'function') {
      config.buttons.ok.callback = okCallBack;
    }

    bootbox.dialog(config);
  };
})(jQuery);
